import { postUser, deleteUser } from "./http";

export interface Process {
  id: number;
  name?: string;
}

export interface ProcessAction {
  id: number;
  processId: number;
  eventType: string;
  transactionId: number | null;
  validations: Array<{
    fieldName: string;
    isOptional?: boolean;
    validators: string[];
    description: string;
  }>;
  fndBody: any[];
}

export const processApi = {
  async getAll(): Promise<Process[]> {
    const res = await postUser("crud/list", {
      module: "process",
      page: "1",
      per_page: "100",
      sort_direction: "+",
      sort_field: "id",
    });
    return res.data || [];
  },

  async create(name: string): Promise<Process> {
    const res = await postUser("crud/upsert", {
      body: { name },
      module: "process",
    });
    return res.body || res.data || res;
  },

  async delete(id: number): Promise<void> {
    // Сначала удаляем все actions
    const actions = await this.getActions(id);
    for (const action of actions) {
      await deleteUser("crud/delete", {
        module: "process-action",
        id: action.id,
      });
    }

    await deleteUser("crud/delete", {
      module: "process",
      id,
    });
  },

  async getActions(processId: number): Promise<ProcessAction[]> {
    const res = await postUser("crud/list", {
      module: "process-action",
      page: "1",
      per_page: "1000",
      sort_direction: "+",
      sort_field: "id",
      filters: { processId },
    });
    return res.data || [];
  },

  async createAction(data: Omit<ProcessAction, "id">): Promise<ProcessAction> {
    const res = await postUser("crud/upsert", {
      body: data,
      module: "process-action",
    });

    return res.body || res.data || res;
  },

  async updateAction(
    id: number,
    data: Partial<ProcessAction>,
  ): Promise<ProcessAction> {
    const res = await postUser("crud/upsert", {
      id,
      body: data,
      module: "process-action",
    });

    return res.body || res.data || res;
  },

  async deleteAction(id: number): Promise<void> {
    await deleteUser("crud/delete", {
      module: "process-action",
      id,
    });
  },

  async getAllActions(): Promise<ProcessAction[]> {
    const res = await postUser("crud/list", {
      module: "process-action",
      page: "1",
      per_page: "1000",
      sort_direction: "+",
      sort_field: "id",
    });
    return res.data || [];
  },
};